import useMomentsUploadForm from './useMomentsUploadForm';

const useDefaultMomentsUploadForm = props => {
  const {
    onUploadStart,
    onUploadComplete,
    job
  } = props;

  return useMomentsUploadForm({
    onUploadStart,
    onUploadComplete,
    job,
    defaultMomentsOnly: true
  });
}

export default useDefaultMomentsUploadForm;
